import React from "react";
import { Check } from "lucide-react";

export const STEP_COLORS = { 1: "#3B82F6", 2: "#A855F7", 3: "#F97316", 4: "#22C55E", 5: "#06B6D4" };

// Colour-coded numbered step box used by the BFX tools; `done` shows a check instead of the number.
export default function Step({ n, title, children, testid, done = false }) {
  const c = STEP_COLORS[n] || "#3B82F6";
  return (
    <div data-testid={testid} data-step-color={c} data-done={done ? "true" : "false"} className="rounded-xl bg-[#080C14]/80 p-3 border border-l-4 space-y-3"
      style={{ borderColor: `${c}55`, borderLeftColor: c, boxShadow: `inset 0 1px 0 ${c}14` }}>
      <div className="text-xs text-zinc-200 flex items-center gap-2 font-semibold">
        <span className="h-5 w-5 rounded-full text-black text-[10px] font-bold flex items-center justify-center" style={{ background: c }}>
          {done ? <Check className="w-3 h-3" /> : n}</span>
        <span style={{ color: c }}>Step {n}</span><span className="text-zinc-300 font-normal">· {title}</span>
      </div>
      {children}
    </div>
  );
}
